/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Preview_Chat_2Inputs */



/**
* | output |
* | --- |
* | "Pascal's supplier contract" |
*
* @param {Sidebar_Preview_Chat_2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sidebar_preview_chat_2 = /** @type {((inputs?: Sidebar_Preview_Chat_2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Preview_Chat_2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Pascals Lieferantenvertrag")
	return /** @type {LocalizedString} */ ("Pascal's supplier contract")
});